import { CloudServerOutlined } from '@ant-design/icons'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderAuthenticationClient } from '../../../authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderOneDriveCommon } from '../common'

const authentication = ProviderAuthenticationClient.Oauth2({
  ...ProviderOneDriveCommon.authentication,
  clientId: ProviderHelperClient.getEnvVariable('outlook', 'CLIENT_ID'),
})

export const ProviderOneDriveClient: ProviderClient = {
  key: ProviderOneDriveCommon.key,
  authentication,
  description: {
    label: 'OneDrive',
    icon: <CloudServerOutlined />,
    triggers: [],
    actions: [],
  },
}
